import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLDOJI', label: 'Doji', lookback: 10 })
